import path from 'node:path'
import { SNAPSHOT_COMMENT, SNAPSHOT_IGNORE } from '@cli-constants/snapshots.js'
import { ensureLine } from './ensure-line.js'

export function ensureSnapshotGitignore(cwd: string): void {
  ensureLine(path.join(cwd, '.gitignore'), SNAPSHOT_IGNORE, SNAPSHOT_COMMENT)
}
